import { TextField, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Box } from "@mui/material";
import { useTarefa } from "../../../../../contexts/TarefaContext";
import { IAgendamentoRepedidamente } from "../../../../../types/tarefa";

const Repetidamente = () => {
    const [tarefa, setTarefa] = useTarefa();
    const agendamento = (tarefa.agendamento || {}) as IAgendamentoRepedidamente;

    const intervalo = agendamento.intervalo !== undefined ? agendamento.intervalo : 15;
    const tipoIntervalo = agendamento.tipoIntervalo || "Minuto";

    function handleIntervaloAlterado(event: React.ChangeEvent<HTMLInputElement>): void {
        event.preventDefault();
        const valor = Number(event.target.value);
        setTarefa({
            ...tarefa,
            agendamento: {
                ...agendamento,
                tipo: "Repetidamente",
                intervalo: isNaN(valor) ? 0 : valor,
                tipoIntervalo: tipoIntervalo
            } as any
        });
    }

    function handleTipoIntervaloAlterado(event: SelectChangeEvent): void {
        event.preventDefault();
        setTarefa({
            ...tarefa,
            agendamento: {
                ...agendamento,
                tipo: "Repetidamente",
                tipoIntervalo: event.target.value as "Hora" | "Minuto",
                intervalo: intervalo
            } as any
        });
    }

    return (
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <TextField
                id="intervalo"
                name="intervalo"
                label="Intervalo"
                type="number"
                variant="outlined"
                required
                onChange={handleIntervaloAlterado}
                value={intervalo}
                sx={{ flex: 1 }}
            />
            <FormControl sx={{ flex: 1 }}>
                <InputLabel id="tipo-intervalo-label">Unidade</InputLabel>
                <Select
                    labelId="tipo-intervalo-label"
                    id="tipoIntervalo"
                    value={tipoIntervalo}
                    label="Unidade"
                    onChange={handleTipoIntervaloAlterado}
                >
                    <MenuItem value="Minuto">Minuto(s)</MenuItem>
                    <MenuItem value="Hora">Hora(s)</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};

export default Repetidamente;